import type { ReactNode } from "react";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

interface WhiteBorderWrapperProps {
  children: ReactNode;
  className?: string;
}

export const WhiteBorderWrapper = ({
  children,
  className,
}: WhiteBorderWrapperProps) => (
  <div
    className={classNames(
      "hidden w-1/2 flex-col items-center justify-center border border-white p-8 lg:flex",
      className,
    )}
  >
    {children}
  </div>
);
